// src/hooks/useProfile.js
import { useState } from 'react';
import profilApi from '../api/profilApi';

export const useProfile = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchProfile = async (email) => {
    setLoading(true);
    try {
      const res = await profilApi.fetchUserData(email);
      setProfile(res.data);
      return res.data;
    } catch (err) {
      console.error('Ошибка при получении данных профиля:', err);
      setError(err);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { profile, loading, error, fetchProfile };
};
